import {Params} from '../getConfig'

export const amplifyHotelixProduction: Params = {
  aws_user_pools_id: 'eu-west-1_Q4WNAeOzs',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '7a4vouom338j6i795v0ilsfiq4',
  oauth_domain: 'hotelix-auth-production.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
